import React, { useState, useEffect } from "react";
import moment from "moment";
import axios from "axios";
import "../ViewCircular/ViewCircular.css";

const API_URL = "https://aadyaacademy.org/api";

const ViewCircular = ({ circular, closeDetail }) => {
  const [categoryName, setCategoryName] = useState("");

  // Fetch category name
  useEffect(() => {
    const fetchCategoryName = async () => {
      try {
        const response = await axios.get(`${API_URL}/circular-categories`);
        const categories = response.data;
        const category = categories.find((cat) => cat.id === parseInt(circular.category));
        setCategoryName(category ? category.name : "No category assigned");
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategoryName("No category assigned");
      }
    };

    if (circular.category) {
      fetchCategoryName();
    } else {
      setCategoryName("No category assigned");
    }
  }, [circular.category]);

  const formatDate = (dateString) => {
    return dateString ? moment(dateString).format("DD/MM/YYYY") : "N/A";
  };

  // ---- Split description into paragraphs ----
  const renderDescription = (description) => {
    if (!description) return "N/A";
    // Split by newline characters if present, otherwise split by periods or "Note:-"
    const paragraphs = description.includes("\n")
      ? description.split("\n").filter((p) => p.trim() !== "")
      : description
          .split(/(?<=\.)\s+|\s*(?<=Note:-)\s+/)
          .filter((p) => p.trim() !== "");
    return paragraphs.map((paragraph, index) => (
      <p key={index} className="circular-description">
        {paragraph}
      </p>
    ));
  };

  return (
    <div className="view-container">
      <div className="view-circular">
        <div className="view-header">
          <h2>Circular Details</h2>
        </div>
        <div className="circular-title-date">
          <div className="circular-title">
            <h4>Title</h4>
            <div className="title-field">{circular.title || "N/A"}</div>
          </div>
          <div className="circular-from-date">
            <h4>From Date</h4>
            <div className="from-date-field">{formatDate(circular.fromdate)}</div>
          </div>
          <div className="circular-to-date">
            <h4>To Date</h4>
            <div className="to-date-field">{formatDate(circular.todate)}</div>
          </div>
        </div>
        <div className="circular-description-row">
          <div className="circular-description">
            <h4>Description</h4>
            <div className="description-field">{renderDescription(circular.description)}</div>
          </div>
        </div>
        <div className="circular-category-row">
          <div className="circular-category">
            <h4>Category</h4>
            <div className="category-field">{categoryName}</div>
          </div>
        </div>
        <div className="circular-attachment">
          <h4>Attachment</h4>
          <div className="attachment-field">
            {circular.pdf_file_path ? (
              <a
                href={`${API_URL}/${circular.pdf_file_path}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Attachment (PDF)
              </a>
            ) : (
              "No attachment"
            )}
          </div>
        </div>
        <div className="view-actions">
          <button className="view-cancel" onClick={closeDetail}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCircular;